export const FillFindingsIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.9219 2.31519L11.9811 2.34253L12.3835 2.45831L13.0929 2.58729C13.3185 2.60458 13.6604 2.62598 13.6604 2.62598C13.8788 2.63574 14.0473 2.65178 14.718 2.61309L15.2985 2.5099L15.7112 2.30353C16.6956 1.42853 17.7187 1.16675 19.0312 1.16675C22.0391 1.16675 24.4453 3.62769 24.4453 6.6355V6.74487C24.4453 7.61987 24.2812 8.44019 23.8984 9.2605L22.5859 11.8308C22.3672 12.323 22.2031 12.8152 22.0938 13.3621L20.0703 24.6277C19.9609 25.2292 19.4687 25.6667 18.8125 25.6667C18.2109 25.7214 17.6641 25.2839 17.5 24.6824L15.9141 18.0652C15.6953 17.1355 14.9297 16.4792 14 16.4792C13.0703 16.4792 12.25 17.1355 12.0312 18.0652L10.4453 24.6824C10.2812 25.2839 9.73438 25.7214 9.13281 25.7214C8.47656 25.6667 7.98438 25.2292 7.875 24.6277L5.85156 13.3621C5.74219 12.8152 5.57812 12.323 5.35937 11.8308L4.04688 9.2605C3.66406 8.44019 3.5 7.61987 3.5 6.74487V6.41675C3.5 3.51831 5.79688 1.16675 8.69531 1.16675C9.84375 1.16675 10.9922 1.60425 11.9219 2.31519Z"
        fill="#FAFAFA"
      />
      <path
        d="M14.9995 4.5C14.4995 4 13.9995 4 12.9995 3.5L11.2371 3.04771C10.4382 2.39913 9.45121 2 8.46426 2C5.9734 2 3.99951 4.14532 3.99951 6.78955V7.08889C3.99951 7.88715 4.1405 8.63552 4.46949 9.38388C5.49951 11 7.99951 16.5 13.6401 14C14.4995 12.5 15.9995 9.29826 15.9995 8.5V6.78955C15.4995 5.5 15.9995 6 14.9995 4.5Z"
        fill="#DB2777"
      />
    </svg>
  );
};
